var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"legend-container"},[_c('span',{class:['legend-color', _vm.props.data.color]}),_c('span',{staticClass:"legend-text"},[_vm._v(" "+_vm._s(_vm.props.data.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }